import { notifications } from '@mantine/notifications';

export const showErrorNotification = (message: string) => {
    notifications.show({
        title: 'Error',
        message,
        color: 'red',
    });
};

export const showSuccessNotification = (message: string) => {
    notifications.show({
        title: 'Success',
        message,
        color: 'green',
    });
};

export const showWarningNotification = (message: string) => {
    notifications.show({
        title: 'Warning',
        message,
        color: 'yellow',
    });
};

export const showLoadingNotification = (
    id: string,
    title: string,
    message: string,
) => {
    notifications.show({
        id,
        loading: true,
        title,
        message,
        autoClose: false,
        withCloseButton: false,
    });
};

export const updateSuccessNotification = (
    id: string,
    title: string,
    message: string,
) => {
    notifications.update({
        id,
        loading: false,
        title,
        message,
        color: 'green',
        autoClose: 5000,
        withCloseButton: true,
    });
};

export const updateFailedNotification = (
    id: string,
    title: string,
    message: string,
) => {
    notifications.update({
        id,
        loading: false,
        title,
        message,
        color: 'red',
        autoClose: 5000,
        withCloseButton: true,
    });
};
